export const GUIDE_FAQS = [
  {
    question: "Is HouseMind only for gifts?",
    answer: "No. Gifts are one part of People & Gifts. HouseMind also covers Food, Home Vault, Home Care, Property Profile, Pets, Emergency & Safety, Household Budget, Vehicles, Subscriptions, Utilities, and Events & Trips. Dashboard and Timeline connect those household areas without replacing the records they own.",
  },
  {
    question: "What makes Ask HouseMind different from a generic chatbot?",
    answer: "Ask HouseMind uses your actual saved household data: your pantry, vehicles, subscriptions, trips, people, and bills. It connects context across modules and opens the right action when there is a clear next step. It will not give generic advice when your specific data is available.",
  },
  {
    question: "Why does Ask HouseMind sometimes say to add more data?",
    answer: "HouseMind will not invent records it does not have. If the relevant pantry item, vehicle detail, trip date, bill history, subscription, or person profile is missing, it will tell you what to add to get a better answer.",
  },
  {
    question: "What is the difference between the dashboard FAB and module Ask AI?",
    answer: "The dashboard Ask HouseMind button opens the global assistant with full cross-module context. Module Ask AI bars are contextual and pass current module details first, such as a vehicle, trip destination, or pantry tab, so answers are scoped to what you are working on.",
  },
  {
    question: "What does the nightly intelligence engine do?",
    answer: "It runs rules across household areas to find meaningful connections: food expiring during a trip, vehicle service due before a road trip, duplicate coverage, subscriptions worth pausing, occasions during travel, Home Care workload, pet-care needs, property-policy readiness, safety reviews, and budget pressure. Results appear on the dashboard only when there is a useful action.",
  },
  {
    question: "Which modules can be shared with Family members?",
    answer: "Family sharing is a collaboration layer for selected records. People & Gifts, Food, Events & Trips, and individual pet profiles can be shared with explicit permissions. Property Profile, Emergency & Safety, Household Budget, Vehicles, subscriptions, utilities, and Home Vault stay private. Nothing is shared automatically.",
  },
  {
    question: "How do I invite a family member?",
    answer: "Open Family, tap Add family member, enter their email, and send the invite. If they already have an account they are added instantly. You can also copy the invite link if email delivery fails.",
  },
  {
    question: "Does voice input submit automatically?",
    answer: "No. The mic button fills the Ask text box with your spoken question. You review it and press Ask yourself.",
  },
  {
    question: "Does AI usage carry over to the next month?",
    answer: "No. AI usage resets each billing month and does not roll over. Track current usage in Settings > AI usage.",
  },
  {
    question: "How do I refresh the cross-module intelligence insights?",
    answer: "Go to Settings > AI usage and tap Refresh household intelligence. The engine also runs automatically every night.",
  },
  {
    question: "Where do I change my plan or billing?",
    answer: "Open Settings and use the Billing section. Downgrades take effect at the end of the current period, so you keep full access until then.",
  },
  {
    question: "How do I contact support?",
    answer: "Open Settings > Support and send a message. Ask HouseMind \"how do I contact support?\" and it will open the section directly.",
  },
  {
    question: "What is the Lease Advisor in Home Vault?",
    answer: "The Lease Advisor is available in Home Vault when your property type is set to Renter. It uses your saved lease records to help with rent negotiation and can draft a negotiation email based on your specific situation.",
  },
  {
    question: "How does the subscription cancel script work?",
    answer: "When HouseMind detects low usage or signals that a subscription may not be worth keeping, you can generate a cancel script. It is written based on your actual usage data and the provider name, giving you a specific reason to cite when you contact the provider.",
  },
];

export const LANDING_FAQS = [
  {
    question: "What household areas does HouseMind cover?",
    answer: "HouseMind covers food and meal planning, people and gifts, events and trips, Home Vault, Home Care, Property Profile, pets, Emergency & Safety, Household Budget, vehicles, subscriptions, and utilities. Dashboard, Daily Brief, notifications, and Timeline bring the right information together across them.",
  },
  {
    question: "Is my data private? Can family members see everything?",
    answer: "Every member of your household has their own independent account. Nothing is shared unless you explicitly choose to share it. You control sharing at the item level, so you can share the grocery list while keeping personal subscriptions and gift planning private.",
  },
  {
    question: "Does HouseMind connect to my bank account?",
    answer: "No. HouseMind does not connect to bank accounts or credit cards. Subscriptions are tracked manually or through optional limited email scanning. This keeps your financial data private and limits unnecessary exposure.",
  },
  {
    question: "Which AI model powers HouseMind?",
    answer: "HouseMind supports Claude from Anthropic and GPT from OpenAI, switchable per user in Settings. Your AI preference is saved to your account and applies across modules.",
  },
  {
    question: "What vehicles does HouseMind support?",
    answer: "Any vehicle with a VIN or registration: cars, trucks, motorcycles, boats, RVs, and more. VIN scanning can auto-fill year, make, model, and recall context when available.",
  },
  {
    question: "Can I use HouseMind with roommates or extended family?",
    answer: "Yes. HouseMind is designed for couples, families, roommates, extended family, and close friends. Each person gets their own private account, and Family sharing is a collaboration layer, not automatic visibility.",
  },
  {
    question: "What happens to my data if I cancel?",
    answer: "Your data is yours. If you cancel, you can export records such as Home Vault entries, vehicle service history, warranties, and other household data as supported export formats.",
  },
  {
    question: "Is there a mobile app?",
    answer: "The web app works on mobile browsers today. A native iOS and Android app is planned for later.",
  },
];
